import { FAQModuleFactory } from './FAQ';
import { AuthModuleFactory } from './Auth';
import { UserModuleFactory } from './User';
import { InvoiceModuleFactory } from './Invoice';
import { SupportModuleFactory } from './Support';
import { SettingModuleFactory } from './Settings';
import { ContractModuleFactory } from './Contract';
import { CampaignModuleFactory } from './Campaign';
import { InvoiceProfileModuleFactory } from './InvoiceProfile';
import AbstractModuleFactory from '@core/shared/module-factory';

/**
 * ### Domain Abstract Module Factory
 * `Factory of factories`: Factory to create all models factories.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class DomainModuleFactory {
  /**
   * ### Authentication Module Factory
   * Return a factory that makes all auth use cases.
   */
  public static auth(): AuthModuleFactory {
    return AuthModuleFactory.new();
  }

  /**
   * ### Campaigns Module Factory
   * Return a factory that makes all campaigns model use cases.
   */
  public static campaign(): CampaignModuleFactory {
    return CampaignModuleFactory.new();
  }

  /**
   * ### Contract Module Factory
   * Return a factory that makes all contracts model use cases.
   */
  public static contract(): ContractModuleFactory {
    return ContractModuleFactory.new();
  }

  /**
   * ### FAQ Module Factory
   * Return a factory that makes all FAQ model use cases.
   */
  public static faq(): FAQModuleFactory {
    return FAQModuleFactory.new();
  }

  /**
   * ### Invoice Module Factory
   * Return a factory that makes all Invoice model use cases.
   */
  public static invoice(): InvoiceModuleFactory {
    return InvoiceModuleFactory.new();
  }

  /**
   * ### Invoice Profile Module Factory
   * Return a factory that makes all Invoice Profile model use cases.
   */
  public static invoiceProfile(): InvoiceProfileModuleFactory {
    return InvoiceProfileModuleFactory.new();
  }

  /**
   * ### Setting Module Factory
   * Return a factory that makes all Setting model use cases.
   */
  public static setting(): SettingModuleFactory {
    return SettingModuleFactory.new();
  }

  /**
   * ### Support Module Factory
   * Return a factory that makes all Support model use cases.
   */
  public static support(): SupportModuleFactory {
    return SupportModuleFactory.new();
  }

  /**
   * ### User Module Factory
   * Return a factory that makes all User model use cases.
   */
  public static user(): UserModuleFactory {
    return UserModuleFactory.new();
  }

  /**
   * Enable the custom error mapping, which
   * transform the normal error into a `ResponseError`.
   */
  public static enableCustomCatch(): void {
    AbstractModuleFactory.ENABLE_CUSTOM_CATCH = true;
  }

  public static clearInstances() {
    DomainModuleFactory.auth().clearInstances();
    DomainModuleFactory.campaign().clearInstances();
    DomainModuleFactory.contract().clearInstances();
    DomainModuleFactory.faq().clearInstances();
    DomainModuleFactory.invoice().clearInstances();
    DomainModuleFactory.invoiceProfile().clearInstances();
    DomainModuleFactory.setting().clearInstances();
    DomainModuleFactory.support().clearInstances();
    DomainModuleFactory.user().clearInstances();
  }

  /**
   * Disable the custom error mapping, which
   * transform the normal error into a `ResponseError`.
   * So by disabling this the error will be normal `Error`
   */
  public static disableCustomCatch(): void {
    AbstractModuleFactory.ENABLE_CUSTOM_CATCH = false;
  }
}
